import $ from 'jquery';

export const loadedData = JSON.parse($('#class-data-loader').html() || '{}');
